const shouldSkipNormalization = (text: string): boolean => {
  return /[_/\\]/.test(text);
};

export const normalizeEditorialSentenceCase = (text?: string): string | undefined => {
  if (!text || !text.trim()) return text;
  if (shouldSkipNormalization(text)) return text;

  const lowerCased = text.toLocaleLowerCase();

  return lowerCased.replace(
    /(^\s*[¿¡"'([{]*)(\p{L})/u,
    (_match, prefix: string, firstLetter: string) => `${prefix}${firstLetter.toLocaleUpperCase()}`
  );
};
